import { useTranslations } from "next-intl"

const Cards = () => {

    const t = useTranslations("Home.your-journey.steps")

    return (
        <div className="w-full flex gap-5 items-start justify-center flex-wrap md:flex-nowrap">
            <div className="rounded-3xl px-2 py-6 bg-sub_primary w-full">
                <h2 className="font-bold text-xl mb-2">
                    {t("step1.title")}
                </h2>
                <p className="text-[#333] text-sub_text">
                    {t("step1.subTitle")}
                </p>
            </div>
            <div className="rounded-3xl px-2 py-6 bg-[#FDF5F0] w-full">
                <h2 className="font-bold text-xl mb-2">
                    {t("step2.title")}
                </h2>
                <p className="text-[#333] text-sub_text">
                    {t("step2.subTitle")}
                </p>
            </div>
            <div className="rounded-3xl px-2 py-6 bg-sub_primary w-full">
                <h2 className="font-bold text-xl mb-2">
                    {t("step3.title")}
                </h2>
                <p className="text-[#333] text-sub_text">
                    {t("step3.subTitle")}
                </p>
            </div>
            <div className="rounded-3xl px-2 py-6 bg-[#FEF7FD] w-full">
                <h2 className="font-bold text-xl mb-2">
                    {t("step4.title")}
                </h2>
                <p className="text-[#333] text-sub_text">
                    {t("step4.subTitle")}
                </p>
            </div>
        </div>
    )
}

export default Cards